import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToLogin,
    navigateToUpdate,
} from '../../../actions/eaTravelRates/routing';
import { getActivePageIndex } from '../../../selectors/eaTravelRates/routing';
import { PAGE_INDICES } from '../../../actions/eaTravelRates/types';

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.LOGIN:
            store.dispatch(navigateToUpdate());
            break;
        default:
            store.dispatch(navigateToLogin());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.UPDATE:
            store.dispatch(navigateToLogin());
            break;
        default:
            store.dispatch(navigateToLogin());
            break;
    }
};
